<template>
  <login :className="className" :title="title" :userType="userType"></login>
</template>

<script>
import login from './Login.vue'
export default {
  name: 'LoginUser',
  components: {login},
  data () {
    return {
      className: 'user',
      title: '사용자',
      userType: 'S'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/LoginUser.vue